<template>
    <div class="t_content_view">
        <div class="t_search_box">
            <div class="t_search_select">
                <span style="color: #6D6D6D;">标签组：</span>
                <el-select size="small" 
                style="width: 180px;"
                v-model="searchdata.tag_group_id" clearable placeholder="请选择">
                    <el-option v-for="item in groupOptions.data" :key="item.id" :label="item.cate_name"
                        :value="item.id" />
                </el-select>
            </div>
            <div class="t_search_select" style="margin-right:20px;margin-left:20px">
                <img src="../assets/img/searchgray.png" style="width:14px" alt="">
                <el-input size="small" v-model="searchdata.tag_title" placeholder="请输入标签名" />
            </div>
            <el-button @click="searchbtn" style="margin-bottom: 10px;" color="#F1F3F9" type="primary">搜索</el-button>
            <el-button @click="resbtn" style="margin-bottom: 10px;" color="#F1F3F9" type="primary">重置</el-button>
        </div>
        <el-button class="t_add_people" color="#4F46E5" type="primary" @click="addqd(1, '')">添加标签组</el-button>
        <!-- <el-button class="t_add_people" color="#4F46E5" type="primary" @click="sametag">同步标签</el-button>
        <el-button class="t_add_people" color="#4F46E5" type="primary" @click="samecomptag">同步企微后台标签</el-button> -->
        <!-- 标签组 -->
        <div v-for="(item, index) in tableData.tableData" :key="index" class="t_zutag">
            <div class="t_zu_name_box">
                <div style="margin-right: 10px;">{{ item.cate_name }}</div>
                <el-button @click="addqd(3, item)" title="编辑标签组" plain circle size="small" type="primary" :icon="Edit" />
            </div>
            <div>
                <el-tag v-for="(item2, index2) in item.tags" :key="index2" style="margin-right: 10px;" type="success">
                    {{ item2.tag_name }}
                </el-tag>
                <el-button plain circle size="small" @click="addtag(index, item)" type="primary" :icon="Plus" />
                <el-button @click="addqd(2, item)" title="编辑标签" plain circle size="small" type="primary" :icon="Edit" />
            </div>
            <input @blur="nowblur(index, 1)" v-focus v-if="item.isaddtag" v-model="aloneadd"
                @input="aloneadd = ($event.target.value || '').replace(/[\s\u3000]/g, '')"
                @keyup.enter="nowblur(index, 2)" style="margin-top:10px" size="small" placeholder="点击回车确定" />
        </div>
    </div>
    <el-dialog v-model="isaddqd" :title="clicktype == 1 ? '添加标签组' : (clicktype == 2 ? '编辑标签' : '编辑标签组')" width="500px">
        <el-form label-width="120px">
            <el-form-item v-if="clicktype != 2" label="标签组名称：">
                <el-input v-model="addlist.qdname" :disabled="nowtag.data.lock==1"
                    @input="addlist.qdname = ($event || '').replace(/[\s\u3000]/g, '')" />
            </el-form-item>
            <template v-if="clicktype != 3">
                <el-form-item v-for="(item, index) in addlist.taglist" :key="index" label="标签名称：">
                    <el-input @input="onTagInput(index, $event)" style="width:280px;margin-right:10px" :disabled="item.lock==1" v-model="item.title" />
                    <template v-if="addlist.taglist.length > 1 && item.lock != 1 && item.is_used">
                        <el-tooltip content="已被渠道或客户使用，不能删除" placement="top">
                            <span>
                                <el-button :icon="Close" size="small" circle disabled />
                            </span>
                        </el-tooltip>
                    </template>
                    <el-button v-else-if="addlist.taglist.length > 1 && item.lock != 1" @click="deltag(index)" :icon="Close" size="small" circle />
                </el-form-item>
                <el-form-item>
                    <el-button style="color:#4F46E5" type="text" :icon="Plus" @click="appendbq" plain>添加标签</el-button>
                </el-form-item>
            </template>
        </el-form>
        <div class="t_cz_box" :style="{ justifyContent: clicktype == 3 ? 'space-between' : 'flex-end' }">
            <div>
                <el-tooltip v-if="clicktype == 3 && nowtag.data.lock != 1 && hasUsedTag(nowtag.data)" content="标签组内存在已被渠道或客户使用的标签，不能删除"
                    placement="top">
                    <span>
                        <el-button type="danger" link disabled>删除标签组</el-button>
                    </span>
                </el-tooltip>
                <el-button v-else-if="clicktype == 3&&nowtag.data.lock!=1" type="danger" @click="deltaggroup" link>删除标签组</el-button>
            </div>
            <div>
                <el-button @click="addrest">取消</el-button>
                <el-button @click="addsub" :loading="issubmitting" color="#4F46E5" type="primary">确定</el-button>
            </div>
        </div>
    </el-dialog>
</template>
<script setup>
import { Delete, Edit, Search, Share, Upload, Plus, Close } from '@element-plus/icons-vue'
import { ref, reactive, provide, onBeforeMount, onMounted, watch, inject } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import { bqlist, addbqgroup, addbq, changebqgroup, changebq, delbq, delbqgroup,sametagfunc,newgettaglist,newgetbqtypev2,newgetbqlistv2,newaddtagitem,newdelgroup,newtonggroup,newtongcompgroup,newcatesave} from '@/assets/js/common.js'
//动态获取接口地址
const _url2 = inject('_url2')
onMounted(() => {
    console.log('onMounted')
    //标签列表
    getlist()
    //标签组下拉选项，固定取全部标签组，不受搜索条件影响
    getgroupList()
})
//搜索
//搜索1数据
const search1 = ref('')

//输入框搜索
const searchname = ref('')
//列表数据
const tableData = reactive({
    tableData: []
})
//标签组下拉数据
const groupOptions = reactive({
    data: []
})
//搜索
const searchdata = reactive({
    tag_title: '',
    tag_group_id: ''
})

const searchbtn = ()=>{
    getlist()
}

//重置
const resbtn = ()=>{
    searchdata.tag_title = ''
    searchdata.tag_group_id = ''
    getlist()
}

//获取标签列表
const getlist = () => {
    newgettaglist(searchdata).then((response) => {
        console.log(response)
        if (response.data.msg.code == 0) {
            tableData.tableData = response.data.data
            //添加是否显示新增input
            for (var i = 0; i < tableData.tableData.length; i++) {
                tableData.tableData[i].isaddtag = false
            }
        }
    })
}

//获取全部标签组，作为筛选下拉的固定数据源
const getgroupList = () => {
    newgetbqtypev2().then((response) => {
        if (response.data.msg.code == 0) {
            groupOptions.data = response.data.data
        }
    })
}

//同步标签
const sametag = ()=>{
    newtonggroup().then((response)=>{
        ElMessage({
            message: '同步成功',
            type: 'success',
        })
        //标签列表
        getlist()
    })
}
//同步企微标签到本地
const samecomptag = ()=>{
    newtongcompgroup().then((response)=>{
        ElMessage({
            message: '同步成功',
            type: 'success',
        })
        //标签列表
        getlist()
    })
}

//新增字段
const addlist = reactive({
    qdname: '',
    taglist: [
        {
            title: '',
            id: ''
        }
    ]
})
//往数组中增加标签
const appendbq = () => {
    addlist.taglist.push({ 'title': '', 'id': '' })
}
//删除标签（仅从弹窗草稿移除，点确定后随整组一次提交）
const deltag = (i) => {
    //标签组至少保留一个标签
    if (addlist.taglist.length <= 1) {
        ElMessage.error('标签组至少保留一个标签')
        return
    }
    addlist.taglist.splice(i, 1)
}
//标签组内是否存在已被渠道或客户使用的标签
const hasUsedTag = (item) => {
    return (item.tags || []).some(function (tag) {
        return tag.is_used
    })
}
//删除标签组
const deltaggroup = () => {
    ElMessageBox.confirm(
        '是否确认删除标签组?',
        '提示',
        {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }
    )
        .then(() => {
            newdelgroup( { id: groupid.value }).then((response) => {
                if (response.data.msg.code == 0) {
                    ElMessage({
                        type: 'success',
                        message: '删除成功！',
                    })
                    //删除了当前筛选的标签组时清空筛选，再刷新列表和下拉
                    if (String(searchdata.tag_group_id) === String(groupid.value)) {
                        searchdata.tag_group_id = ''
                    }
                    getlist()
                    getgroupList()
                    isaddqd.value = false
                }
            })
        })
        .catch(() => {
            ElMessage({
                type: 'info',
                message: '已取消',
            })
        })

}

//新增弹窗是否显示
const isaddqd = ref(false)
const clicktype = ref('')
//当前标签组id
const groupid = ref('')
//提交中，防止重复提交
const issubmitting = ref(false)

//标签名称输入时禁止空格
const onTagInput = (i, val)=>{
    addlist.taglist[i].title = (val || '').replace(/[\s\u3000]/g, '')
}
//当前选择的标签组
const nowtag = reactive({
    data:{}
})
//点击新增标签组/编辑标签/编辑标签组
const addqd = async (type, item) => {
    //1新增标签组 2编辑标签 3编辑标签组名称
    var fullTags = null
    if (type == 2 || type == 3) {
        //列表可能被标签名搜索过滤，编辑前重新取该组全部标签，避免漏提交被当成删除
        try {
            var tagResponse = await newgetbqlistv2({ tag_group_id: item.id })
            if (!tagResponse || !tagResponse.data || tagResponse.data.msg.code != 0) {
                return
            }
            fullTags = (tagResponse.data.data || []).map(function (tag) {
                return Object.assign({}, tag, { title: tag.tag_name })
            })
        } catch (e) {
            return
        }
    }
    isaddqd.value = true
    clicktype.value = type
    if (type == 1) {
        //新增
        addlist.qdname = ''
        addlist.taglist = [
            {
                title: '',
                id: ''
            }
        ]
        groupid.value = ''
        nowtag.data = {}
    } else if (type == 2) {
        //编辑标签，只处理标签
        addlist.qdname = ''
        addlist.taglist = fullTags || []
        groupid.value = item.id
        nowtag.data = item
    } else {
        //编辑标签组名称，只处理标签组；带上完整标签用于判断能否删除
        addlist.qdname = item.cate_name
        addlist.taglist = []
        groupid.value = item.id
        nowtag.data = Object.assign({}, item, { tags: fullTags || [] })
    }
}
//取消新增
const addrest = () => {
    isaddqd.value = false
    //刷新列表
    getlist()
}



//提交新增/编辑
const addsub = async () => {
    //标签组名称和标签名称统一去掉前后空格
    addlist.qdname = (addlist.qdname || '').trim()
    if(clicktype.value != 2 && !addlist.qdname){
        ElMessage.error('请输入标签组名称')
        return
    }
    if(clicktype.value != 3){
        for(var j = 0; j < addlist.taglist.length; j++){
            addlist.taglist[j].title = (addlist.taglist[j].title || '').trim()
            if(!addlist.taglist[j].title){
                ElMessage.error('标签名称不能为空')
                return
            }
        }
        if(addlist.taglist.length == 0){
            ElMessage.error('标签组至少保留一个标签')
            return
        }
    }
    //防止重复提交
    if (issubmitting.value) {
        return
    }
    issubmitting.value = true
    //整包提交：新增传 title+tags，编辑标签传 id+tags，编辑标签组只传 id+title
    var payload = {}
    if (clicktype.value == 1) {
        payload = {
            title: addlist.qdname,
            tags: addlist.taglist.map(function (tag) {
                return { title: tag.title }
            })
        }
    } else if (clicktype.value == 2) {
        payload = {
            id: groupid.value,
            tags: addlist.taglist.map(function (tag) {
                var item = { title: tag.title }
                if (tag.id != '' && tag.id != null) {
                    item.id = tag.id
                }
                return item
            })
        }
    } else {
        payload = { id: groupid.value, title: addlist.qdname }
    }
    try {
        var response = await newcatesave(payload)
        if (response && response.data && response.data.msg.code == 0) {
            ElMessage({
                message: clicktype.value == 1 ? '添加成功！' : '修改成功！',
                type: 'success',
            })
            getlist()
            getgroupList()
            isaddqd.value = false
        }
    } catch (e) {
        //错误提示由请求拦截器统一处理
    } finally {
        issubmitting.value = false
    }
}
//单独新增
const aloneadd = ref('')
//失去焦点事件
const nowblur = (i, type) => {
    tableData.tableData[i].isaddtag = false
    console.log(type)
    if (type == 2) {
        //新增标签
        aloneadd.value = (aloneadd.value || '').trim()
        if(!aloneadd.value){
            ElMessage.error('请输入标签名称')
            return
        }
        newaddtagitem( { title: aloneadd.value, groupId: groupid.value }).then((response) => {
            if (response.data.msg.code == 0) {
                ElMessage({
                    message: '添加成功！',
                    type: 'success',
                })
                //刷新列表
                getlist()
            }
        })
    }

}
//单独添加标签
const addtag = (i, item) => {
    tableData.tableData[i].isaddtag = true
    groupid.value = item.id
    aloneadd.value = ''
}


</script>
<style scoped>


:deep(.t_search_box .el-input__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}

.t_add_people {
    margin-top: 20px;
    margin-bottom: 20px;
}


/* .t_content_view {
    padding: 20px;
} */

/* .t_cz_box {
    display: flex;
} */

.t_zu_name_box {
    display: flex;
    margin-bottom: 20px;
}

.t_zutag {
    margin-bottom: 30px;
    margin-top: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #f1f1f1;
}
:deep(.t_search_select .el-select__wrapper)  {
    background-color: #F1F3F9;
    box-shadow: 0 0 0 0 black;
}
</style>